function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 13.5h-9V4a1.5 1.5 0 00-1.5-1.5h-5A1.5 1.5 0 003 4v16a1.5 1.5 0 001.5 1.5H20a1.5 1.5 0 001.5-1.5v-5a1.5 1.5 0 00-1.5-1.5zM4.5 20v-2h2v-1.5h-2v-2h3V13h-3v-2h2V9.5h-2v-2h3V6h-3V4h5v16h-5zM20 20h-2v-3h-1.5v3h-2v-2H13v2h-2v-5h9v5z",
  fill: "currentColor"
});

function SvgSqftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgSqftIcon;